import { GuestState } from ".";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: GuestState = {
  tab: 0,
  guests: [],
  guest: null,
  loading: false,
  saveCheckValue:false,
  saveEditValue:false
};

export const guestSlice = createSlice({
  name: "guest",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setTab: (state, action: PayloadAction<number>) => {
      state.tab = action.payload;
    },
    setGuest: (state, action: PayloadAction<any>) => {
      state.guest = action.payload;
    },
    setSaveCheckValue: (state, action: PayloadAction<any>) => {
      state.saveCheckValue = action.payload;
    },
    setEditValue: (state, action: PayloadAction<any>) => {
      state.saveEditValue = action.payload;
    },
    addGuest: (state, action) => {
      state.guests.unshift(action.payload);
    },
    updateGuest: (state, action) => {
      const guest = action.payload;
      state.guest = guest;
      const index = state.guests.findIndex((g) => g._id === guest._id);
      if (index !== -1) {
        state.guests[index] = guest; // ✅ replace the existing guest
      }
      // state.bookings.every(({ _id }, i) => {
      //   if (booking._id === _id) {
      //     state.bookings[i] = booking;
      //     return false;
      //   }
      //   return true;
      // });
    },
    setGuests: (state, action) => {
      state.guests = action.payload;
    },
    deleteGuest: (state, action) => {
      const guestId = action.payload;
      state.guests = state.guests.filter((guest: any) => guest._id !== guestId);
    },
    
  },
});

const guestReducer = guestSlice.reducer;

export const guestActions = guestSlice.actions;
export default guestReducer;
